import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: "AIzaSyA296i0v9r9i4et5-ZrQ8iVbYBgm0UyxOQ",
  authDomain: "speakly-67b01.firebaseapp.com",
  databaseURL: "https://speakly-67b01-default-rtdb.firebaseio.com",
  projectId: "speakly-67b01",
  storageBucket: "speakly-67b01.firebasestorage.app",
  messagingSenderId: "665499409095",
  appId: "1:665499409095:web:78114a108316f12a3afce2",
  measurementId: "G-DZ3K343VTE"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

export const analytics = getAnalytics(app);
export const googleProvider = new GoogleAuthProvider();
export const messaging = getMessaging(app);